"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToWishlistCommand = void 0;
class AddToWishlistCommand {
    constructor(userId, studyId, expectedState, isLocal) {
        this.userId = userId;
        this.studyId = studyId;
        this.expectedState = expectedState;
        this.isLocal = isLocal;
    }
}
exports.AddToWishlistCommand = AddToWishlistCommand;
